export async function getTelephones(request) {
    const telephones = await request({
        url: "/profile/telephones",
        method: "get"
      });
    return telephones;
}

export async function updateTelephones(request, telephones) {
    const new_tele = await request({
        method: "post",
        url: "/profile/telephones",
        data: {
            telephones
        }
      });
    return new_tele;
}
